import decoder from '../../../lib/decoder';
import ModelAddress from './address'

const STEP_BILL_PHIS = 'step_bill_phis';
const STEP_BILL_LEGAL = 'step_bill_legal';

const USER_TYPE_PHIS = 1;
const USER_TYPE_LEGAL = 2;

const COMPANY_TYPE_HEAD = 'HEAD';
const COMPANY_TYPE_UNIT = 'UNIT';
const COMPANY_TYPE_ENTREPRENEUR = 'ENTREPRENEUR';
const COMPANY_TYPE_FOREIGN = 'FOREIGN';

function ModelUser() {
	this.id = 0;
	
	this.fields = {
		user_type: {
			type: decoder.type.INT,
			field: 'UF_USER_TYPE',
			value: 0,
			disabled: false,
			error: false,
			values: [
				{
					value: USER_TYPE_PHIS,
					title: 'Физическое лицо'
				},
				{
					value: USER_TYPE_LEGAL,
					title: 'Юридическое лицо или ИП'
				}
			]
		},
		last_name: {
			type: decoder.type.STRING,
			field: 'LAST_NAME',
			value: '',
			disabled: false,
			error: false
		},
		name: {
			type: decoder.type.STRING,
			field: 'NAME',
			value: '',
			disabled: false,
			error: false
		},
		second_name: {
			type: decoder.type.STRING,
			field: 'SECOND_NAME',
			value: '',
			disabled: false,
			error: false
		},
		legal_type: {
			type: decoder.type.STRING,
			field: 'UF_LEGAL_TYPE_XML_ID',
			value: '',
			disabled: false,
			error: false,
			values: [
				{
					value: COMPANY_TYPE_HEAD,
					title: 'Головная организация'
				},
				{
					value: COMPANY_TYPE_UNIT,
					title: 'Обособленное подразделение (филиал)'
				},
				{
					value: COMPANY_TYPE_ENTREPRENEUR,
					title: 'Индивидуальный предприниматель'
				},
				{
					value: COMPANY_TYPE_FOREIGN,
					title: 'Иностранная организация'
				}
			]
		},
		inn: {
			type: decoder.type.STRING,
			field: 'UF_INN',
			value: '',
			disabled: false,
			error: false
		},
		kpp: {
			type: decoder.type.STRING,
			field: 'UF_KPP',
			value: '',
			disabled: false,
			error: false
		},
		company_title: {
			type: decoder.type.STRING,
			field: 'WORK_COMPANY',
			value: '',
			disabled: false,
			error: false
		},
		ogrn: {
			type: decoder.type.STRING,
			field: 'UF_OGRN',
			value: '',
			disabled: false,
			error: false
		},
		company_phone: {
			type: decoder.type.STRING,
			field: 'WORK_PHONE',
			value: '',
			disabled: false,
			error: false
		},
		company_fax: {
			type: decoder.type.STRING,
			field: 'WORK_FAX',
			value: '',
			disabled: false,
			error: false
		},
		bik: {
			type: decoder.type.STRING,
			field: 'UF_BIK',
			value: '',
			disabled: false,
			error: false
		},
		bank: {
			type: decoder.type.STRING,
			field: 'UF_BANK',
			value: '',
			disabled: false,
			error: false
		},
		bank_city: {
			type: decoder.type.STRING,
			field: 'UF_BANK_CITY',
			value: '',
			disabled: false,
			error: false
		},
		payment_account: {
			type: decoder.type.STRING,
			field: 'UF_PAYMENT_ACCOUNT',
			value: '',
			disabled: false,
			error: false
		},
		correspondent_account: {
			type: decoder.type.STRING,
			field: 'UF_OFFSET_ACCOUNT',
			value: '',
			disabled: false,
			error: false
		},
		address_legal_equal_actual: {
			type: decoder.type.BOOL,
			field: 'UF_LEGAL_AS_ACTUAL',
			value: false,
			disabled: false,
			error: false
		},
		address: {
			value: new ModelAddress(),
			field: {
				postal_code: 'PERSONAL_ZIP',
				region: 'PERSONAL_STATE',
				city: 'PERSONAL_CITY',
				street: 'PERSONAL_STREET',
				house: 'UF_PERSONAL_HOUSE',
				building: 'UF_PERSONAL_BUILDING',
				flat: 'UF_PERSONAL_FLAT'
			}
		},
		company_address: {
			value: new ModelAddress('company'),
			field: {
				postal_code: 'WORK_ZIP',
				region: 'WORK_STATE',
				city: 'WORK_CITY',
				street: 'WORK_STREET',
				house: 'UF_WORK_HOUSE',
				building: 'UF_WORK_BUILDING',
				flat: 'UF_WORK_FLAT'
			}
		},
		company_legal_address: {
			value: new ModelAddress('company_legal'),
			field: {
				postal_code: 'UF_UR_POSTAL_CODE',
				region: 'UF_UR_STATE',
				city: 'UF_UR_ADDRESS_CITY',
				street: 'UF_UR_ADDRESS_STREET',
				house: 'UF_UR_HOUSE',
				building: 'UF_UR_BUILDING',
				flat: 'UF_UR_FLAT'
			}
		}
	}
}

ModelUser.prototype.formData = function () {
	let fields = [],
		formData = new FormData();
	
	if (this.fields.user_type.value === USER_TYPE_PHIS) {
		fields = [
			'user_type',
			'last_name',
			'name',
			'second_name',
			'address',
		];
	} else if (this.fields.user_type.value === USER_TYPE_LEGAL) {
		fields = [
			'user_type',
			'legal_type',
			'inn',
			'kpp',
			'company_title',
			'ogrn',
			'company_phone',
			'company_fax',
			'bik',
			'bank',
			'bank_city',
			'payment_account',
			'correspondent_account',
			'address_legal_equal_actual',
			'company_address',
			'company_legal_address',
		];
	}
	
	fields.forEach(key => {
		let field = this.fields[key];
		if (key === 'address' || key === 'company_address' || key === 'company_legal_address') {
			field.value.fillFormData(formData)
		} else {
			if (!field.disabled) {
				if (key === 'address_legal_equal_actual') {
					formData.append(key, field.value ? 'Y' : '')
				} else {
					formData.append(key, field.value)
				}
			}
		}
	})
	
	return formData
};

ModelUser.prototype.clearErrors = function () {
	for (let key in this.fields) {
		if (Object.hasOwnProperty.call(this.fields, key)) {
			if (key === 'address' || key === 'company_address' || key === 'company_legal_address') {
				this.fields[key].value.clearErrors()
			} else {
				this.fields[key].error = false
			}
		}
	}
};

ModelUser.prototype.setError = function (key, status) {
	if (Object.hasOwnProperty.call(this.fields, key)) {
		this.fields[key].error = status
	} else {
		this.fields.address.value.setError(key, status);
		this.fields.company_address.value.setError(key, status);
		this.fields.company_legal_address.value.setError(key, status);
	}
};

ModelUser.prototype.getStep = function () {
	if (this.fields.user_type.value === USER_TYPE_PHIS) {
		return STEP_BILL_PHIS;
	} else if (this.fields.user_type.value === USER_TYPE_LEGAL) {
		return STEP_BILL_LEGAL;
	}
	return null;
};

ModelUser.constant = {
	step: {
		PHIS: STEP_BILL_PHIS,
		LEGAL: STEP_BILL_LEGAL
	},
	userType: {
		PHIS: USER_TYPE_PHIS,
		LEGAL: USER_TYPE_LEGAL
	},
	companyType: {
		HEAD: COMPANY_TYPE_HEAD,
		UNIT: COMPANY_TYPE_UNIT,
		ENTREPRENEUR: COMPANY_TYPE_ENTREPRENEUR,
		FOREIGN: COMPANY_TYPE_FOREIGN
	}
};

ModelUser.decode = function (jsonUser, jsonBillingUser) {
	if (!jsonUser) jsonUser = {};
	if (!jsonBillingUser) jsonBillingUser = {};
	
	let model = new ModelUser();
	
	model.id = decoder.intValue(jsonUser['ID'], 0);
	
	for (let key in model.fields) {
		if (Object.hasOwnProperty.call(model.fields, key)) {
			let field = model.fields[key];
			
			if (key === 'address' || key === 'company_address' || key === 'company_legal_address') {
				field.value.decode(jsonUser, jsonBillingUser, field.field);
			} else {
				if (Object.hasOwnProperty.call(jsonBillingUser, key)) {
					field.value = decoder.value(field.type, jsonBillingUser[key], field.value);
				}
				if (field.value) {
					field.disabled = true;
				} else {
					field.value = decoder.value(field.type, jsonUser[field.field], field.value);
				}
			}
		}
	}
	
	if (jsonBillingUser['company_postal_code']) {
		model.fields.address_legal_equal_actual.disabled = true
	}
	
	if (model.fields.user_type.value) {
		model.fields.user_type.disabled = true
	}
	
	if (jsonUser[model.fields.user_type.field]) {
		model.fields.legal_type.disabled = true
	}
	
	return model;
};

export default ModelUser;